export const whenAppears = function(element_string, handler) {

    document.getElementById('app').arrive(element_string, function() {

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    handler(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        });

        observer.observe(this);

    });
}